<template>
  <div class="home-info">
    <!-- <div v-wechat-title="$route.meta.title"></div> -->
    <Head :webInfoObj="webInfoObj"></Head>
    <router-view></router-view>
    <Footer
      
      :webInfoObj="webInfoObj"
    ></Footer>
  </div>
</template>

<script>
import Head from '@/components/base/head.vue'
import Footer from '@/components/base/footer.vue'
import { headFootData } from '@/api/configuration'
import { get } from '../utils/helpers'
export default {
  name: 'Home',
  components: {
    Head,
    Footer
  },
  data() {
    return {
      webInfoObj: {} // 头部尾部信息
    }
  },
  created() {
    this.getHeadFootData()
  },
  methods: {
    //获取头部尾部数据
    getHeadFootData() {
      this.$store.commit('STRWEBSITEID', this.$route.query.strWebSiteId)
      headFootData({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.webInfoObj = get(['data'], res.data)
          document.title = get(['data', 'strName'], res.data)
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
</style>
